import Page from 'components/layout/Page';
import Benefits from './components/benefits/Benefits';
import Companies from './components/companies/Companies';
import Gender from './components/gender/Gender';
import Intro from './components/intro/Intro';
import Methodology from './components/methodology/Methodology';
import Talent from './components/talent/Talent';
import { StyledPage } from './ManTechCar.styled';

type MandecarProps = {
  manfreditesCount: number;
};

const ManTechCarComponent: React.FC<MandecarProps> = ({ manfreditesCount }) => {
  // Render.
  // ---------------------------------------------------------------------------
  return (
    <Page hasScrollTop pageVariant="light">
      <StyledPage>
        <Intro manfreditesCount={manfreditesCount} />
        <Talent />
        <Benefits />
        <Companies />
        <Gender />
        {/* <Insights /> */}
        <Methodology />
      </StyledPage>
    </Page>
  );
};

export default ManTechCarComponent;
